import { User } from "@firebase/auth";
import { useMemo, useState } from "react";
import { BlockContentView } from "src/ui/BlockContentView";
import { DemoCheckScoreButton } from "src/ui/DemoCheckScoreButton";
import { DemoQuizLoader } from "src/ui/DemoQuizLoader";
import { DemoScorePanel } from "src/ui/DemoScorePanel";
import { QuizSubmissionView } from "src/ui/QuizSubmissionView";
import { QuizSubmitPanel } from "src/ui/QuizSubmitPanel";
import { RootLayout } from "src/ui/RootLayout";
import { SubmissionStateFullLoader } from "src/ui/SubmissionStateFullLoader";
import { SubmissionSource } from "src/ui/SubmissionStateLoader";
import { CurrentTimeProvider } from "src/ui/useCurrentMinute";
import { loadHeader } from "./loadHeader";

export function DemoQuizView({ user }: { user: User }) {
  const [showSolutions, setShowSolutions] = useState(false);

  const source = useMemo((): SubmissionSource => ({ origin: "anonymous" }), []);

  return (
    <CurrentTimeProvider>
      <RootLayout>
        <DemoQuizLoader>
          {({ quiz, sharedData, headerData }) => (
            <>
              <BlockContentView value={loadHeader(headerData)} />
              <SubmissionStateFullLoader compositeUserId={user.uid} canSubmit={true} quiz={quiz} source={source}>
                {(submissionState) => (
                  <QuizSubmissionView
                    quiz={quiz}
                    sharedData={sharedData}
                    submissionState={submissionState}
                    showSolutions={showSolutions}
                    panel={
                      <>
                        {showSolutions ? (
                          <DemoScorePanel
                            quiz={quiz}
                            sharedData={sharedData}
                            submissionState={submissionState}
                            setShowSolutions={setShowSolutions}
                          />
                        ) : (
                          <DemoCheckScoreButton submissionState={submissionState} setShowSolutions={setShowSolutions} />
                        )}
                        <QuizSubmitPanel submissionState={submissionState} />
                      </>
                    }
                  />
                )}
              </SubmissionStateFullLoader>
            </>
          )}
        </DemoQuizLoader>
      </RootLayout>
    </CurrentTimeProvider>
  );
}
